module.exports = __webpack_public_path__ + "img/step5-b.e37771d4.png";